import React from 'react';

const CaseStudyHero = () => {
  return (
    <section className="bg-white pt-16 pb-16">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 pt-10 md:pt-14 lg:pt-20 text-center">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
          Fixing a Broken Delivery System That Blocked Work and Killed Trust
        </h1>
        <p className="text-xl text-gray-600 leading-relaxed">
          How I redesigned a bloated process to increase speed, rebuild trust, and help the client triple their budget.
        </p>
      </div>
    </section>
  );
};

export default CaseStudyHero;